import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Reviews from "./reviews";
import { productPropType } from "components/propTypes";
import { useSelector } from "react-redux";

// <Reviews> is designed to stand on its own (i.e. on a standalone page) and
// therefore expects its props to be at the root of its props. When rendering
// this component on a PDP, it is specifically *not* the primary resource, so
// its props are relegated to a nested object. This wrapper component simply
// allows <Reviews> to continue believe it is the most important thing.

export function PDPInlineReviews(props) {
  const reviews = useSelector(state => state.reviews) || {};
  const workingFilters = useSelector(state => state.workingFilters);
  const { averageRating, count, data, page, perPage, sort, summary } = reviews;

  return (
    <div data-test-id="pdp-full-reviews" ref={props.innerRef}>
      <Reviews
        averageRating={averageRating}
        count={count}
        data={data}
        page={page}
        perPage={perPage}
        product={props.product}
        shouldLoadReviews={props.shouldLoadReviews}
        sort={sort}
        summary={summary}
        workingFilters={workingFilters}
        writingReview={props.writingReview}
        dispatch={props.dispatch}
      />
    </div>
  );
}

PDPInlineReviews.propTypes = {
  dispatch: PropTypes.func.isRequired,
  innerRef: PropTypes.object,
  product: productPropType.isRequired,
  shouldLoadReviews: PropTypes.bool,
  writingReview: PropTypes.bool,
};

/* eslint-disable react/jsx-props-no-spreading */
const withRef = forwardRef((props, ref) => <PDPInlineReviews {...props} innerRef={ref} />);
withRef.displayName = "PDPInlineReviews";
export default withRef;
